export default __webpack_public_path__ + "static/cherryswap-0b4a6c440e889ed3c1b7d8cc31f07790.png";